
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/neighbourhoods/southall",
      function () {
        return require("private-next-pages/neighbourhoods/southall.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/neighbourhoods/southall"])
      });
    }
  